module.exports = {"apiUrl":"https://sietest.sie.se","isProduction":true,"isStaging":false,"isDev":false};